import React, { useContext } from 'react';
import { convertBlockDataToRicos } from 'ricos-content/libs/convertBlockDataToRicos';
import { RicosContext, EditorContext, ModalContext, PluginsEventsContext } from 'ricos-context';
import { s as styles, G as GiphyApiInputModal } from '../giphyApiInputModal-f3cd73f8.js';
import { GIPHY_TYPE } from '../types.js';
import 'classnames';
import 'lodash';
import 'wix-rich-content-ui-components';
import '../style-inject.es-e7b07dd7.js';
import '../dataHooks.js';
import '../toolbar/giphySelector.js';
import 'react-custom-scrollbars';
import 'react-infinite-scroller';
import '../giphyEmptyState-32a217da.js';
import '../constants.js';
import 'wix-rich-content-common';
import '../toolbar/getGiphyProxyUrl.js';
import '../icons/PoweredByGiphy.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const GiphyInsertModal = ({
  componentData,
  nodeId,
  modalId,
  showCloseButton,
  getGiphyUrl
}) => {
  const { t, isMobile, languageDir } = useContext(RicosContext);
  const { getEditorCommands } = useContext(EditorContext);
  const modalService = useContext(ModalContext) || {};
  const pluginsEvents = useContext(PluginsEventsContext);
  const closeModal = () => {
    modalService.closeModal(modalId);
  };
  const addBlockWithFocus = (insertBlock) => setTimeout(() => insertBlock(), 50);
  const onGifAdd = (gif) => {
    const editorCommands = getEditorCommands();
    const data = convertBlockDataToRicos(GIPHY_TYPE, __spreadProps(__spreadValues({}, componentData), { gif }));
    let insertGif = () => {
      editorCommands == null ? void 0 : editorCommands.insertBlockWithBlankLines(GIPHY_TYPE, data);
    };
    if (nodeId) {
      insertGif = () => {
        editorCommands == null ? void 0 : editorCommands.setBlock(nodeId, GIPHY_TYPE, data);
      };
    }
    addBlockWithFocus(insertGif);
  };
  const pluginEvents = {
    onPluginAction: (searchTerm) => pluginsEvents.publishPluginPopoverSearch({ pluginId: GIPHY_TYPE, searchTerm })
  };
  return /* @__PURE__ */ React.createElement("div", { className: styles.modalWrapper }, /* @__PURE__ */ React.createElement(
    GiphyApiInputModal,
    {
      getGiphyUrl,
      componentData,
      t,
      isMobile,
      languageDir,
      onGifAdd,
      onCloseRequested: closeModal,
      helpers: pluginEvents,
      showCloseButton
    }
  ));
};

export { GiphyInsertModal as default };
//# sourceMappingURL=InsertModal.js.map
